import { createCashedOutEntriesStore } from '@/hooks/create-cashed-out-entries-store';

/** Minimal shape needed to restore the confirmed card after list virtualization. */
export type PickemCashedOutEntry = {
    id: string;
    cashedOutAmount: number;
};

/** Pickem's session record of entries cashed out in place from the entries list. */
export const usePickemCashedOutEntries = createCashedOutEntriesStore<PickemCashedOutEntry>();
